import React from 'react';

export const Building = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.156" height="21.5" viewBox="0 0 20.156 21.5">
      <g id="building" data-name="building" transform="translate(0 0)">
        <path
          id="Path_631"
          data-name="Path 631"
          d="M19.838.1a.672.672,0,0,1,.318.571V20.828a.672.672,0,0,1-.672.672H15.453a.672.672,0,0,1-.672-.672V18.812H13.438v2.016a.672.672,0,0,1-.672.672H.672A.672.672,0,0,1,0,20.828V13.437A.672.672,0,0,1,.46,12.8l7.6-2.534V6.047a.672.672,0,0,1,.371-.6L19.183.071a.672.672,0,0,1,.654.03ZM8.063,11.683,1.344,13.921v6.235H8.063Zm1.344,8.474h2.688V18.141a.672.672,0,0,1,.672-.672h2.688a.672.672,0,0,1,.672.672v2.016h2.688V1.759l-9.406,4.7Z"
          transform="translate(0 0)"
          fill="#ffffff"
          fillRule="evenodd"
        />
        <path
          id="Path_632"
          data-name="Path 632"
          d="M2,13.75H3.344v1.344H2Zm2.688,0H6.031v1.344H4.688ZM2,16.438H3.344v1.344H2Zm2.688,0H6.031v1.344H4.688Zm5.375-5.375h1.344v1.344H10.063Zm2.688,0h1.344v1.344H12.75ZM10.063,13.75h1.344v1.344H10.063Zm2.688,0h1.344v1.344H12.75Zm2.688-2.688h1.344v1.344H15.438Zm0,2.688h1.344v1.344H15.438ZM10.063,8.375h1.344V9.719H10.063Zm2.688,0h1.344V9.719H12.75Zm2.688,0h1.344V9.719H15.438ZM10.063,5.688h1.344V7.031H10.063Zm2.688,0h1.344V7.031H12.75Zm2.688,0h1.344V7.031H15.438Zm0-2.688h1.344V4.344H15.438Z"
          transform="translate(0.688 1.031)"
          fill="#ffffff"
        />
      </g>
    </svg>
  );
};
